import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { vewVendorPlanDetails } from "../../redux/services/SubscriptionServices/Subscription.Services";

function ViewAssignedPlan() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  // ---------- Helpers ----------
  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  const formatPrice = (val) =>
    val !== null && val !== undefined && val !== ""
      ? `₹${Number(val).toFixed(2)}`
      : "-";

  const formatLimit = (val) => (val === -1 ? "Unlimited" : val ?? 0);

  const formatDaysLeft = (val) => {
    if (val === null || val === undefined) return "-";
    return `${Number(val).toFixed(1)} days`;
  };

  const fetchSubscriptionDetails = async () => {
    try {
      setLoading(true);
      const payload = { subscription_id: id };
      const res = await vewVendorPlanDetails(payload);
      let data = null;
      if (res?.success && res?.data) {
        data = res.data;
      } else if (res?.data?.data) {
        data = res.data.data;
      } else if (res?.id) {
        data = res;
      }
      setSubscription(data || null);
    } catch (error) {
      console.log("Error:", error);
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchSubscriptionDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // ---------- Loading ----------
  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h5 className="mt-3">Loading Subscription Details...</h5>
      </div>
    );
  }

  // ---------- Not Found ----------
  if (!subscription) {
    return (
      <div className="text-center py-5">
        <h5>Subscription not found</h5>
        <button className="add-btn mt-3" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
    );
  }

  const { vendor, plan, module, category, subscription: sub, usage, payments } = subscription;

  return (
    <>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Subscription Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/subscription-list">Subscriptions</Link>
            <span className="mx-2">/</span>
            <span>View</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="card mt-2">
          <div className="card-body p-4">

            {/* ===== VENDOR INFORMATION ===== */}
            {vendor && (
              <div className="mb-4">
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                  Vendor Information
                </h6>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Vendor ID</label>
                    <input type="text" className="form-control" value={vendor.user_id || "-"} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" value={vendor.name || "-"} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Mobile</label>
                    <input type="text" className="form-control" value={vendor.mobile || "-"} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Email</label>
                    <input type="text" className="form-control" value={vendor.email || "-"} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Business Name</label>
                    <input type="text" className="form-control" value={vendor.business_name || "-"} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">KYC Status</label>
                    <input
                      type="text"
                      className={`form-control ${vendor.kyc_status === "approved" ? "view-status-active" : "view-status-inactive"}`}
                      value={vendor.kyc_status ? vendor.kyc_status.charAt(0).toUpperCase() + vendor.kyc_status.slice(1) : "-"}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            )}

            {/* ===== PLAN INFORMATION ===== */}
            {plan && (
              <div className="mb-4">
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                  Plan Information
                </h6>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Plan Name</label>
                    <input type="text" className="form-control" value={plan.name || "-"} readOnly />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Description</label>
                    <input type="text" className="form-control" value={plan.description || "-"} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Price</label>
                    <input type="text" className="form-control view-price" value={formatPrice(plan.price)} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Original Price</label>
                    <input type="text" className="form-control view-original-price" value={formatPrice(plan.original_price)} readOnly />
                  </div>
                  {/* <div className="col-md-4">
                    <label className="form-label">Duration (Days)</label>
                    <input type="text" className="form-control" value={plan.duration_days ?? "-"} readOnly />
                  </div> */}
                  <div className="col-md-4">
                    <label className="form-label">AI Call Limit</label>
                    <input type="text" className="form-control" value={formatLimit(plan.ai_call_limit)} readOnly />
                  </div>
                  {/* <div className="col-md-4">
                    <label className="form-label">Staff Limit</label>
                    <input type="text" className="form-control" value={formatLimit(plan.staff_limit)} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Product Limit</label>
                    <input type="text" className="form-control" value={formatLimit(plan.product_limit)} readOnly />
                  </div> */}
                </div>
              </div>
            )}

            {/* ===== MODULE & CATEGORY ===== */}
            <div className="mb-4">
              <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                Module
              </h6>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Module</label>
                  <input type="text" className="form-control" value={module?.name || "-"} readOnly />
                </div>
                {/* <div className="col-md-6">
                  <label className="form-label">Category</label>
                  <input type="text" className="form-control" value={category?.name || "-"} readOnly />
                </div> */}
              </div>
            </div>

            {/* ===== SUBSCRIPTION DETAILS ===== */}
            {sub && (
              <div className="mb-4">
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                  Subscription Details
                </h6>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Start Date</label>
                    <input type="text" className="form-control" value={formatDateTime(sub.start_date)} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">End Date</label>
                    <input type="text" className="form-control" value={formatDateTime(sub.end_date)} readOnly />
                  </div>
                  {/* <div className="col-md-4">
                    <label className="form-label">Duration (Days)</label>
                    <input type="text" className="form-control" value={sub.duration_days ?? "-"} readOnly />
                  </div> */}
                  {/* <div className="col-md-4">
                    <label className="form-label">Days Left</label>
                    <input type="text" className="form-control" value={formatDaysLeft(sub.days_left)} readOnly />
                  </div> */}
                  <div className="col-md-4">
                    <label className="form-label">Amount Paid</label>
                    <input type="text" className="form-control view-price" value={formatPrice(sub.amount_paid)} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Payment Status</label>
                    <input
                      type="text"
                      className={`form-control ${sub.payment_status === "paid" ? "view-status-active" : "view-status-inactive"}`}
                      value={sub.payment_status ? sub.payment_status.charAt(0).toUpperCase() + sub.payment_status.slice(1) : "-"}
                      readOnly
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Payment Method</label>
                    <input type="text" className="form-control" value={sub.payment_method || "-"} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Status</label>
                    <input
                      type="text"
                      className={`form-control ${sub.status === "active" ? "view-status-active" : "view-status-inactive"}`}
                      value={sub.status ? sub.status.charAt(0).toUpperCase() + sub.status.slice(1) : "-"}
                      readOnly
                    />
                  </div>
                  {/* <div className="col-md-4">
                    <label className="form-label">Approved By</label>
                    <input type="text" className="form-control" value={sub.approved_by ?? "-"} readOnly />
                  </div> */}
                  <div className="col-md-4">
                    <label className="form-label">Approved At</label>
                    <input type="text" className="form-control" value={formatDateTime(sub.approved_at)} readOnly />
                  </div>
                </div>
              </div>
            )}

            {/* ===== USAGE ===== */}
            {usage && (
              <div className="mb-4">
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                  Usage
                </h6>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">AI Calls Used</label>
                    <input type="text" className="form-control" value={usage.ai_calls?.used ?? 0} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">AI Calls Limit</label>
                    <input type="text" className="form-control" value={formatLimit(usage.ai_calls?.limit)} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">AI Calls Remaining</label>
                    <input type="text" className="form-control" value={formatLimit(usage.ai_calls?.remaining)} readOnly />
                  </div>
                  {/* <div className="col-md-4">
                    <label className="form-label">Staff Added</label>
                    <input type="text" className="form-control" value={usage.staff?.added ?? 0} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Staff Limit</label>
                    <input type="text" className="form-control" value={formatLimit(usage.staff?.limit)} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Staff Remaining</label>
                    <input type="text" className="form-control" value={usage.staff?.remaining ?? 0} readOnly />
                  </div> */}
                </div>
              </div>
            )}

            {/* ===== FEATURES ===== */}
            {plan?.features && Array.isArray(plan.features) && plan.features.length > 0 && (
              <div className="mb-4">
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                  Features
                </h6>
                <div className="row g-2">
                  {plan.features.map((feature, idx) => (
                    <div className="col-md-6" key={idx}>
                      <div className="d-flex align-items-center border rounded px-3 py-2">
                        <span className="badge bg-primary me-2">{idx + 1}</span>
                        <span>{feature}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ===== PAYMENTS ===== */}
            {payments && Array.isArray(payments) && payments.length > 0 && (
              <div className="mb-4">
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                  Payment History
                </h6>
                 <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Payment ID</th>
                        <th>Amount</th>
                        <th>Method</th>
                        <th>Status</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {payments.map((p, idx) => (
                        <tr key={p.id ?? idx}>
                          <td>{idx + 1}</td>
                          <td>{p.payment_id || "-"}</td>
                          <td>{formatPrice(p.amount)}</td>
                          <td className="text-capitalize">{p.payment_method || "-"}</td>
                          <td>
                            <span className={`badge ${p.status === "success" ? "bg-success" : "bg-danger"}`}>
                              {p.status ? p.status.charAt(0).toUpperCase() + p.status.slice(1) : "-"}
                            </span>
                          </td>
                          <td>{formatDateTime(p.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}

export default ViewAssignedPlan;